import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class SugestaoValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.descricao )) {
			refs.sugestaoField.focusedOut = true;
			validated = false;
		}		

        return validated;
    }
}
